import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'

import { useCurrentModal } from '../../../../../components/modals/ModalsContext'
import { useNavigationWithModalCloser } from '../../../../../utils/contexts/NavigationContext'
import {
  useOpenDetailsTemplatesModal,
  useOpenEditTemplatesModal
} from '../../../../../utils/routes/modals/modalsActions'
import { useRemoveTemplate } from '../../_request/removeTemplate'

export const useTemplateActions = item => {
  const canEdit = useSessionPermission('editTemplate')
  const canDelete = useSessionPermission('deleteTemplate')

  const { data: entity } = useCurrentModal()
  const navigate = useNavigationWithModalCloser()
  const openDetailsModal = useOpenDetailsTemplatesModal()
  const openEditModal = useOpenEditTemplatesModal()

  const [deleteItems, { loading }] = useRemoveTemplate()

  const singleOptions = [
    ...appendIf(true, {
      value: 'seeDetails',
      icon: 'RiSearch2Line',
      onClick: () => openDetailsModal(item)
    }),

    ...appendIf(canEdit, {
      value: 'edit',
      icon: 'RiPencilLine',
      onClick: () => openEditModal({ entity, id: item.id })
    }),

    ...appendIf(canEdit, {
      value: 'Editar Conteúdo',
      icon: 'RiFileEditLine',
      onClick: () => navigate(`/templates/${item.id}/content`)
    }),

    ...appendIf(canDelete, {
      value: 'remove',
      color: COLORS.red,
      icon: 'RiDeleteBin5Line',
      onClick: () => deleteItems([item.id])
    })
  ]

  return [singleOptions, loading]
}
